import logo from "../assets/logo.jpg";

export default function PhoneMockup() {
  return (
    <div className="phone-wrap" data-testid="hero-phone-mockup">
      <div className="phone-glow" aria-hidden="true" />
      <div className="phone">
        <div className="phone-notch" aria-hidden="true" />
        <div className="phone-screen">
          <div className="phone-statusbar" aria-hidden="true">
            <span>9:41</span>
            <span className="status-icons">●●●</span>
          </div>
          <div className="phone-brand">
            <img src={logo} alt="LleGO" className="phone-logo" />
          </div>
          <div className="trip-card">
            <div className="trip-route">
              <span>Montevideo</span>
              <span className="trip-arrow">→</span>
              <span>Punta del Este</span>
            </div>
            <div className="trip-bar"><div className="trip-bar-fill" /></div>
            <div className="trip-meta">
              <span className="trip-battery">78% batería</span>
              <span className="trip-verdict"><span className="verdict-dot" />LLEGÁS</span>
            </div>
            <div className="trip-stops">
              <span className="stop-chip">UTE Colonia</span>
              <span className="stop-chip">Mové Maldonado</span>
            </div>
            <div className="trip-cost">
              <span>Eléctrico <b>$U 210</b></span>
              <span>Nafta <b>$U 890</b></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
